var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowingPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5.50048C10.4 7.01985 9.326 8.25048 8 8.25048C6.674 8.25048 5.6 7.01985 5.6 5.50048C5.6 3.9811 6.674 2.75048 8 2.75048C9.326 2.75048 10.4 3.9811 10.4 5.50048ZM8 9.09672C5.6088 9.09672 3.356 7.74349 1.9192 5.50048C3.356 3.25746 5.6088 1.90328 8 1.90328C10.3912 1.90328 12.644 3.25746 14.0808 5.50048C12.644 7.74349 10.3912 9.09672 8 9.09672ZM8 0C4.5792 0 1.5992 2.21542 0 5.50048C1.5992 8.78553 4.5792 11 8 11C11.4208 11 14.4008 8.78553 16 5.50048C14.4008 2.21542 11.4208 0 8 0Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowingPassword);
export default __webpack_public_path__ + "static/media/showing-password.5cf3080c577c3ae283293f4513ae93ad.svg";
export { ForwardRef as ReactComponent };